import styles from "./index.module.css";

export const FullPageLoad: React.FC = () => (
  <div className={styles.fullPage}>
    <div>LOADING...</div>
  </div>
);
